import { useEffect } from "react";
import { Link } from "@tanstack/react-router";
import { X } from "lucide-react";
import { ProgramView } from "./ProgramView";

/**
 * A program beside the current screen. Non-modal: no backdrop, the page next to it stays usable (Phase 4: typing case
 * notes). The host places it (className): the layout docks it at the right; the case workspace can put it in its right
 * column. Esc or Close closes it, except an Esc another control already used (the search box closing its list).
 */
export function ProgramPanel({ slug, state, onStateChange, onClose, className = "" }: {
  slug: string; state?: string; onStateChange: (state: string | undefined) => void; onClose: () => void; className?: string;
}) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape" && !e.defaultPrevented) onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);
  return (
    <aside role="complementary" aria-label="Program details"
      className={`overflow-y-auto border-l border-slate-200 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-950 ${className}`}>
      <div className="mb-3 flex items-center justify-between">
        <Link to="/directory/programs/$slug" params={{ slug }} search={{ state }} onClick={onClose}
          className="text-sm text-brand-700 hover:underline dark:text-brand-100">Open full page</Link>
        <button type="button" className="btn-ghost" onClick={onClose}><X size={14} /> Close</button>
      </div>
      <ProgramView slug={slug} state={state} onStateChange={onStateChange} layout="panel" />
    </aside>
  );
}
